import { render, staticRenderFns } from "./customerSerivces.vue?vue&type=template&id=680c8728&scoped=true&"
import script from "./customerSerivces.vue?vue&type=script&lang=js&"
export * from "./customerSerivces.vue?vue&type=script&lang=js&"
import style0 from "./customerSerivces.vue?vue&type=style&index=0&id=680c8728&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c8728",
  null
  
)

export default component.exports